import type { ReactElement } from 'react';
import { useEffect, useState } from 'react';

import { Modal } from '@/modules/perseo-billing/ui/react/src/components/beta';
import { useMediaQuery } from '@/modules/perseo-billing/ui/react/src/ui-hooks';

import type { TModalProps } from '../../ui/react/src/components/beta/modal/modal.interface';

interface ModalWrapperProps extends TModalProps {
  roundedType?: 'FIXED_BOTTOM' | 'FULL_VIEW';
  styling?: TModalProps;
}

const RoundStyle: { [key in ModalTypes]: string } = {
  FIXED_BOTTOM: 't-md',
  FULL_VIEW: 'none'
};

export enum ModalTypes {
  FIXED_BOTTOM = 'FIXED_BOTTOM',
  FULL_VIEW = 'FULL_VIEW'
}

const getClassNames = (modalProps: ModalWrapperProps): string => {
  const isBottom = modalProps.roundedType === ModalTypes.FIXED_BOTTOM;

  let className = isBottom ? DEFAULT_CLASS_NAME : '';
  const propClassName = modalProps.className || '';
  className = propClassName ? `${className} ${propClassName}` : className;
  return className;
};

const DEFAULT_CLASS_NAME =
  'co-mx-auto co-h-auto co-mt-auto lg:co-my-auto co-mb-0';

export const ModalWrapper = (props: ModalWrapperProps): ReactElement => {
  const open = props.open;
  const isMobile = useMediaQuery('lg');
  const [customStyles, setCustomStyles] = useState<ModalWrapperProps>();

  useEffect(() => {
    const className = getClassNames(props);
    if (!props) return;

    const roundedStyle = RoundStyle[props?.roundedType ?? ModalTypes.FULL_VIEW];

    setCustomStyles({
      ...props,
      open,
      className: className,
      breakpoint: 'lg',
      rounded: isMobile || !!roundedStyle
    });
  }, [isMobile, open, props]);

  return <Modal {...customStyles}>{props.children}</Modal>;
};
